<template>
  <div>
    <hlx-search
      :label-value="customiseColumnsSearchLabel"
      :clearable="true"
      @search-key="searchTheads"
    >
    </hlx-search>
  </div>
  <br />
  <div v-if="selectable == true" class="flex m-10">
    <div v-show="list.length !== 0 && searchKey == ''" class="draggable">
      <label class="check-container">
        <!-- {{ "Select all" }} -->
        {{ selectAllComp }}
        <i
          v-if="partiallySelected == true"
          class="icon-minus-regular"
          style="
            color: white;
            font-size: 14px !important;
            position: relative;
            font-weight: bold;
            top: 1px;
            left: -76px;
            z-index: 100;
          "
        ></i>
        <input
          style="margin-right: 15px"
          type="checkbox"
          :class="'select-all' + unique"
          :checked="false"
          @click="selectAll"
        />
        <span :id="'select-all-checkmark' + unique" class="checkmark"></span>
      </label>
    </div>
    <draggable
      v-model="filteredList"
      class="dragArea list-group w-full"
      handle=".handle"
      tag="transition-group"
      :component-data="{
        tag: 'ul',
        type: 'transition-group',
        name: !drag ? 'flip-list' : null,
      }"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <!-- @change="log" -->
      <div
        v-for="element in filteredList"
        :key="element.id"
        class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center draggable"
      >
        <i
          v-if="searchKey == ''"
          class="icon-drag-vertical-filled handle"
          style="margin-right: 15px"
        ></i>
        <label
          class="check-container"
          :class="{
            'checkContainer-readOnly': element.readOnly,
            'checkContainer-disabled': element.disabled,
          }"
          >{{ element.name }}
          <input
            :id="'check-drag' + unique + element.id"
            type="checkbox"
            :checked="element.checked"
            :disabled="element.disabled"
            :class="'check-drag' + unique"
            @click="checkItem(element, $event)"
          />
          <span
            class="checkmark"
            :class="{
              'check-readOnly': element.readOnly,
              'check-disabled': element.disabled,
            }"
          ></span>
        </label>
      </div>
    </draggable>
  </div>
  <div v-else class="flex m-10">
    <draggable
      v-model="filteredList"
      class="dragArea list-group w-full"
      handle=".handle"
      tag="transition-group"
      :component-data="{
        tag: 'ul',
        type: 'transition-group',
        name: !drag ? 'flip-list' : null,
      }"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <!-- @change="log" -->
      <div
        v-for="element in list"
        :key="element.name"
        class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center draggable"
      >
        <i
          class="icon-drag-vertical-filled handle"
          style="margin-right: 15px"
        ></i
        >{{ element.name }}
      </div>
    </draggable>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
import HlxSearch from "../components/SearchComponent.vue";
import { toRaw } from "vue";

export default defineComponent({
  name: "HlxDraggables",
  components: {
    draggable: VueDraggableNext,
    HlxSearch,
  },
  props: {
    customiseColumnsSearchLabel: {
      type: String,
      default: "Search",
    },
    selectAllComp: {
      type: String,
      default: "Select all",
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  data() {
    return {
      searchKey: "",
      copyOfList: [],
      filteredList: [],
      display: "Handle",
      enabled: true,
      dragging: false,
      drag: false,
      select_all: false,
      all_checked: true,
      partially_checked: false,
      atleastOne: false,
      unique: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    partiallySelected() {
      return this.partially_checked;
    },
  },
  watch: {
    filteredList: {
      handler(val) {
        val;
        val = val.map((item) => toRaw(item));
        console.log(this.copyOfList, this.list, val, "ccf");
        this.$emit("change", [...val]);
      },
      immediate: true,
      deep: true,
    },
    list: {
      handler(val) {
        const copy = JSON.parse(JSON.stringify([...val]));
        this.copyOfList = copy;
        this.filteredList = copy;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.partially_checked = false
    if (this.list.length !== 0) {
      if (this.selectable === true) {
        this.all_checked = true;
        this.list.forEach((ele) => {
          if (ele.readOnly === true) {
            ele.disabled = true;
          }
          if (ele.checked === false) {
            this.all_checked = false;
          }
          if (ele.checked === true) {
            this.atleastOne = true;
          }
        });
        if (this.all_checked === true) {
          document.querySelector(".select-all" + this.unique).checked = true;
        }
        if (this.atleastOne === true && this.all_checked === false) {
          this.partially_checked = true;
        } else {
          this.partially_checked = false;
        }
        if (this.partially_checked === true) {
          document
            .getElementById("select-all-checkmark" + this.unique)
            .classList.add("theme");
        }
      }
    }
  },
  methods: {
    searchTheads(e) {
      this.searchKey = e;
      this.filteredList = this.copyOfList.filter((ele) =>
        ele.name.toLowerCase().includes(e.toLowerCase())
      );
    },
    log(e) {
      console.log(this.copyOfList, this.list, e, "ccf");
      this.$emit("change", JSON.parse(JSON.stringify(this.copyOfList)));
    },
    selectAll($event) {
      this.select_all = $event.target.checked;
      if (this.select_all === true) {
        this.partially_checked = false;
        document
          .querySelectorAll("[id^=check-drag" + this.unique + "]")
          .forEach((ele) => {
            if (ele.disabled === false) {
              ele.checked = true;
            }
          });
        this.copyOfList.forEach((ele) => {
          if (ele.disabled === false) {
            ele.checked = true;
          }
        });

        document
          .getElementById("select-all-checkmark" + this.unique)
          .classList.remove("grey");
        document
          .getElementById("select-all-checkmark" + this.unique)
          .classList.add("theme");
      } else {
        this.partially_checked = false;
        document
          .querySelectorAll("[id^=check-drag" + this.unique + "]")
          .forEach((ele) => {
            if (ele.disabled === false) {
              ele.checked = false;
            }
            if (ele.checked === true) {
              this.partially_checked = true;
              document
                .getElementById("select-all-checkmark" + this.unique)
                .classList.add("theme");
            }
          });
        this.copyOfList.forEach((ele) => {
          if (ele.disabled === false) {
            ele.checked = false;
          }
        });
        if (this.partially_checked === false) {
          document
            .getElementById("select-all-checkmark" + this.unique)
            .classList.remove("theme");
          document
            .getElementById("select-all-checkmark" + this.unique)
            .classList.add("grey");
        } else if (this.partially_checked === true) {
          document
            .getElementById("select-all-checkmark" + this.unique)
            .classList.remove("grey");
          document
            .getElementById("select-all-checkmark" + this.unique)
            .classList.add("theme");
        }
      }
      this.$emit("change", this.copyOfList);
    },
    checkItem(val, $event) {
      this.atleastOne = false;
      this.all_checked = true;
      val.checked = $event.target.checked;
      if ($event.target.checked === false) {
        document.querySelector(".select-all" + this.unique).checked = false;
      }
      // if (this.all_checked === true) {
      //   document.querySelector('.select-all').checked = true
      // }
      this.$emit("change", this.copyOfList);
      this.copyOfList.forEach((ele) => {
        if (ele.checked === false) {
          this.all_checked = false;
        }
        if (ele.checked === true) {
          this.atleastOne = true;
        }
      });
      if (this.all_checked === true) {
        document.querySelector(".select-all" + this.unique).checked = true;
        document
          .getElementById("select-all-checkmark" + this.unique)
          .classList.add("theme");
      } else if (
        document.getElementById("select-all-checkmark" + this.unique)
      ) {
        this.partially_checked = false;
        document
          .getElementById("select-all-checkmark" + this.unique)
          .classList.add("grey");
      }
      if (this.atleastOne === true && this.all_checked === false) {
        this.partially_checked = true;
        document
          .getElementById("select-all-checkmark" + this.unique)
          .classList.remove("grey");
        document
          .getElementById("select-all-checkmark" + this.unique)
          .classList.add("theme");
      } else if (this.all_checked === true) {
        this.partially_checked = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped></style>
